import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iMatcherSingleCustomInputState, iSingleEntityMatchResponse } from 'store/types/matcher';

export const initialState: iMatcherSingleCustomInputState = {
  matcherSingleCustomInput: null
};

export const matcherSingleCustomInputSlice = createSlice({
  name: 'matcherSingleCustomInput',
  initialState,
  reducers: {
    setMatcherSingleCustomInput: (state, action: PayloadAction<iSingleEntityMatchResponse>) => {
      // Replace the entire assembly state
        const matcherSingleCustomInput: iSingleEntityMatchResponse = action.payload
        state.matcherSingleCustomInput = matcherSingleCustomInput
    }
  }
});

// The exported reducer
export default matcherSingleCustomInputSlice.reducer;
// Export the action
export const { setMatcherSingleCustomInput } = matcherSingleCustomInputSlice.actions;
// Optional selector
export const assemblyResultReducerState = (state: RootState) => state.assemblyResult;
// in store/slices/matcherSingleCustomInputSlice.ts
export const matcherSingleCustomInputSelector = (state: RootState) =>
    state.matcherSingleCustomInput.matcherSingleCustomInput;